import React from 'react';

import { SearchBar, Button } from 'dyl-components';

import './index.scss';

const ArchivedReportsToolbar = ({
    search,
    onChangeSearch,
    onSearchSubmit,
    cancelFunction,
    isReading,
}) => {
    return (
        <div className='ArchivedReportsToolbar'>
            <div className='ArchivedReportsToolbar__search'>
                <SearchBar
                    isSearching={isReading}
                    search={search}
                    searchFcn={onSearchSubmit}
                    cancelFcn={cancelFunction}
                    placeholder='Search by contact name or account name'
                    addClassNames='DylNumbers__search'
                    onChange={onChangeSearch}
                    bottomError
                />
            </div>

            <Button
                className='ArchivedReportsToolbar__button'
                disabled
            >
                Bulk Actions
            </Button>
        </div>
    );
};

export default ArchivedReportsToolbar;